module.exports = __webpack_public_path__ + "static/media/logo_ragrom_white.ebf29863.svg";